import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=e08f28f6"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports